import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SpinnerComponent} from './spinner.component';
import {IconModule} from "@app-web-central/web/shared/ui/icon";

@NgModule({
  imports: [
    IconModule,
    CommonModule
  ],
  declarations: [
    SpinnerComponent
  ],
  exports: [
    SpinnerComponent
  ],
})
export class SpinnerModule {
}
